import { render } from "./NewsroomPage2.vue?vue&type=template&id=55f30407"
import script from "./NewsroomPage2.vue?vue&type=script&lang=js"
export * from "./NewsroomPage2.vue?vue&type=script&lang=js"

import exportComponent from "/Users/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__